<div class="process-edit"
  [ngClass]="{'process-edit--modal':modal}">
  @if(processEdit.showHeaderInfo){
    <div class="common-status-message__g-container-warning">
      <i class="lf-icon-warning-full common-status-message__icon-md"></i>
      <div class="common-status-message__g-content">
          <div class="common-status-message__g-icon-text-content">
            <div class="common-status-message__g-title-subtitle">
              <span class="common-status-message__g-subtitle"
              [afTranslate]="'process.edit.redesign-concept'">
                _Este proceso ya se está aplicando. Los cambios podrían afectar a otras configuraciones (tarea de gestión, alertas, asociación de documentos, notificaciones...)
              </span>
            </div>
            <button class="common-button__icon-xs-noborder"
                (click)="processEdit.showHeaderInfo = !processEdit.showHeaderInfo">
                <i class="lf-icon-close-thick common-icon__sm"></i>
            </button>
          </div>
          @if(concept.productTypeId === 2 && !concept.poll){
            <div class="common-status-message__g-buttons-container">
              <button class="common-button__link"
                (click)="processEdit.showHeaderInfo = false">
                <span class="common-button__link-text"
                  [afTranslate]="'customize-concept.redesign-concept'">_Desbloquear y rediseñar concepto</span>
              </button>
            </div>
          }
      </div>
    </div>
  }
  <div
    class="process-edit__container"
    [ngClass]="{
      'process-edit__container--modal': modal
    }">
    <div class="process-edit__container-top"
      [ngClass]="{
        'process-edit__container-top--modal': modal
      }">
      <div class="process-edit__diagram-zone-container"
        [ngClass]="{'process-edit__diagram-zone-container--editing': !processEdit.showHelp}">
          <div class="process-edit__main"
          [ngClass]="{'process-edit__main--modal': modal}"
          [ngShow]="!processEdit.showHelp">
            <div class="process-edit__diagram-title-container">
              @if(processEdit.alert === null){
                @if(processEdit.process.title !==''){
                  <div class="process-edit__diagram-title-tag">
                    <p class="process-edit__diagram-title-text">
                      {{processEdit.process.title}}
                    </p>
                  </div>
                }
               
              } @else {
                <div class="common-status-message__g-container-info"
                  [ngClass]="processEdit.alert && !processEdit.alert?.isError? 'common-status-message__g-container-success' : 'common-status-message__g-container-alert'">
                  <i class="common-status-message__icon-md"
                  [ngClass]="processEdit.alert && !processEdit.alert?.isError? 'lf-icon-check-round-full' : 'lf-icon-close-round-full'"></i>
                  <div class="common-status-message__g-content">
                      <div class="common-status-message__g-icon-text-content">
                        <div class="common-status-message__g-title-subtitle">
                          <span class="common-status-message__g-subtitle">
                            {{processEdit.alert?.text}}
                          </span>
                        </div>
                        <button class="common-button__icon-xs-noborder"
                          (click)="processEdit.alert = null">
                            <i class="lf-icon-close-thick common-icon__sm"></i>
                        </button>
                      </div>
                  </div>
                </div>
              }
            </div>
            <rappid class="process-edit__rappid-container"
              [component]="processEdit.rappid"
              [modal]="modal"
              [designing]="processEdit.designing"
              [defaultStepName]="'process.edit.default-state-title'"
              [from]="'edit'"
              [model]="processEdit.model"
              (onAction)="onCellActionOn($event)"
              (addStateEmit)="addState($event)">
            </rappid>
          </div>


          <div class="process-edit__main-help"
            [ngShow]="processEdit.showHelp">
            <div class="process-edit__diagram-zone-title"
              [afTranslate]="'process.edit.draw-zone-help-title'">
              Zona de diagramación
            </div>
            <div class="process-edit__diagram-zone-description">
              <span [afTranslate]="'process.edit.draw-zone-help-line'">
                _Usa la barra de herramientas para añadir estados y organizar el proceso. Debes crear al menos dos estados. Todos los estados deben estar conectados.
              </span>
            </div>
          </div>

        <div class="common-toolbox__container"
          [ngClass]="{'process-edit__toolbox-editing': !processEdit.showHelp}">
          <div class="common-toolbox__inner-container">
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'process.edit.add-state' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('addState')">
              <i class="lf-icon-process-step-new common-icon__md"></i>
            </button>
          </div>
          <div class="common-toolbox__separator"></div>
          <div class="common-toolbox__inner-container">
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'process.edit.zoom-in' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('zoomMore')">
              <i class="lf-icon-zoom-in common-icon__md"></i>
            </button>
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'process.edit.zoom-out' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('zoomMinus')">
              <i class="lf-icon-zoom-out common-icon__md"></i>
            </button>
          </div>
          <div class="common-toolbox__separator"></div>
          <div class="common-toolbox__inner-container">
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'process.edit.center-in' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('centerSelected')">
              <i class="lf-icon-map-marker common-icon__md"></i>
            </button>
            <button class="common-button__icon-md-noborder"
             pTooltip="{{'process.edit.show-all-diagram' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('fit')">
              <i class="lf-icon-visible common-icon__md"></i>
            </button>
          </div>
          <div class="common-toolbox__separator"></div>
          <div class="common-toolbox__inner-container">
            <button class="common-button__icon-md-noborder"
              pTooltip="{{'process.edit.distribute-automatically' | afTranslate}}"
              tooltipPosition="top"
              (click)="rappidAction('layout')">
              <i class="lf-icon-reorganize common-icon__md"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="process-edit__diagram-properties-container"
        [ngClass]="{'process-edit__diagram-properties-container--modal':modal}">
        <div class="process-edit__diagram-properties-inner-container">
          <field-type-text-simple #title 
            class="w-[100%]"
            [field]="processEdit.titleField"
            [preSelectItem]="processEdit.selection.title"
            (itemSelected)="titleChanged($event.newValue)">
          </field-type-text-simple>
          <div class="w-[100%]">
            <field-type-rich-text-editable
              #description
              [field]="processEdit.descriptionField"
              [preSelectItem]="processEdit.selection.description"
              (itemSelected)="descriptionChanged($event.newValue)">
            </field-type-rich-text-editable>
          </div>
          @if(processEdit.selection.type ==='app.State' && skin !=='icam-red'){
            <label class="common-radio-button__label-container"
              for="archived-concept"
              (click)="changeArchiveConceptObject()">
              <input id="archived-concept"
                type="checkbox"
                class="common-radio-button__no-input"
                [disabled]="processEdit.hasArchivedSelect && !processEdit.selection.cell.attributes.compliance.archiveConceptObject"
                [(ngModel)]="processEdit.selection.cell.attributes.compliance.archiveConceptObject">
              <div class="common-switch__container-small"
                [ngClass]="{'common-switch__container-small--active': processEdit.selection.cell.attributes.compliance.archiveConceptObject}">
                  <div class="common-switch__icon-circle-little"></div>
              </div>
              <p class="common-radio-button__text"
                [afTranslate]="'process.edit.send-to-archive'">Switch habilitado</p>
                <i class="lf-icon-information common-icon__md"
                  [pTooltip]="'process.edit.send-to-archive-explain'| afTranslate"
                  [tooltipStyleClass]="'common-tooltip__big-size'"
                  [tooltipPosition]="'top'"

                  ></i>
            </label>
            @if(concept.allowPublicShare){
               <label class="common-radio-button__label-container"
                  for="lock-com-to-manager">
                  <input id="lock-com-to-manager"
                    type="checkbox"
                    class="common-radio-button__no-input"
                    [(ngModel)]="processEdit.selection.cell.attributes.compliance.lockComToManager">
                  <div class="common-switch__container-small"
                      [ngClass]="{'common-switch__container-small--active': processEdit.selection.cell.attributes.compliance.lockComToManager}">
                      <div class="common-switch__icon-circle-little"></div>
                  </div>
                  <p class="common-radio-button__text"
                    [afTranslate]="'process.edit.block-com-manager'">Switch habilitado</p>
                </label>
                <label class="common-radio-button__label-container"
                  for="delete-anonimization">
                  <input id="delete-anonimization"
                    type="checkbox"
                    class="common-radio-button__no-input"
                    [(ngModel)]="processEdit.selection.cell.attributes.compliance.deleteAnonymizationAlert">
                  <div class="common-switch__container-small"
                    [ngClass]="{'common-switch__container-small--active': processEdit.selection.cell.attributes.compliance.deleteAnonymizationAlert}">
                      <div class="common-switch__icon-circle-little"></div>
                  </div>
                  <p class="common-radio-button__text"
                    [afTranslate]="'process.edit.delete-anonimization-alert'">Switch habilitado</p>
                    <i class="lf-icon-information common-icon__md"
                      [pTooltip]="'process.edit.delete-anonimization-alert-explain'| afTranslate"
                      [tooltipStyleClass]="'common-tooltip__big-size'"
                      [tooltipPosition]="'top'"

                      ></i>
                </label>
            }
           
          }
        </div>
      </div>
    </div>
    <div  class="process-edit__container-bottom">
      <ul class="common-stepper__informative-block-container">
        <li class="common-stepper__informative-block">
          <div class="common-stepper__informative-container">
            <p class="common-stepper__informative-text">
              <span class="common-stepper__informative-text--number">1-</span>
              <span [afTranslate]="'process.edit.how-to-1-title'"></span>
            </p>
          </div>
        </li>
        <li class="common-stepper__informative-block">
          <div class="common-stepper__informative-container">
            <p class="common-stepper__informative-text">
              <span class="common-stepper__informative-text--number">2-</span>
              <span [afTranslate]="'process.edit.how-to-2-title'"></span>
            </p>
          </div>
        </li>
        <li class="common-stepper__informative-block">
          <div class="common-stepper__informative-container">
            <p class="common-stepper__informative-text">
              <span class="common-stepper__informative-text--number">3-</span>
              <span [afTranslate]="'process.edit.how-to-3-title'"></span>
            </p>
          </div>
        </li>
        <li class="common-stepper__informative-block">
          <div class="common-stepper__informative-container">
            <p class="common-stepper__informative-text">
              <span class="common-stepper__informative-text--number">4-</span>
              <span [afTranslate]="'common.save'"></span>
            </p>
          </div>
        </li>
      </ul>
      @if(!modal){
        <div class="process-edit__buttons-container">
          @if(!processEdit.isNew){
            <button class="common-button__text-noborder"
              (click)="deleteProcess()">
              <span class="common-button__text-title"
                [afTranslate]="'process.edit.delete'">
                _Eliminar proceso
              </span>
            </button>
          }
          <button class="common-button__text-border"
            (click)="cancel()">
            <span class="common-button__text-title"
              [afTranslate]="'common.cancel'">_cancelar</span>
          </button>
          <button class="common-button__text"
            (click)="saveProcess()">
            <span class="common-button__text-title"
              afTranslate="process-edit.save-process">
              _guardar proceso
            </span>
          </button>
        </div>
      }
    </div>
  </div>
</div>
